const columns = (cambioEstatus) => ({
    plantilla: [
        { label: 'Nombre plantilla', name: 'titulo', filtrar: true },
        { label: 'Días a liberar', name: 'diasHabilitar', filtrar: true },
        { label: 'Tipo de material', name: 'ntipoActividad', filtrar: true },
        { label: 'Usuario creación', name: 'nombreUsuarioCreacion', filtrar: true },
        { label: 'Fecha y hora de creación', name: 'fechaCreacion', type: { opcion: 'date', accion: 4 }, filtrar: true },
        { label: 'Usuario modifica', name: 'nombreUsuarioModifica', filtrar: true },
        { label: 'Fecha y hora de modificación', name: 'fechaModificacion', type: { opcion: 'date', accion: 4 }, filtrar: true },
        {
            label: 'Estatus',
            name: 'estatus',
            filtrar: false,
            type: { opcion: 'switch', accion: cambioEstatus }
        }
    ]
});

export default columns;
